<template>
  <v-dialog
    v-model="dialogDetail"
    max-width="1200px"
    transition="dialog-transition"
    v-if="dialogDetail"
    @keydown.esc="close"
  >
  <v-card flat class="no__padding">
    <v-card-title class="pa-0" v-if="!loadingDetail" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
      <h2 v-if="detailItem != null">Objednávka {{detailItem.variabilni_symbol}}</h2>
    </v-card-title>
    <v-card-text class="pa-0 mt-4" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
      <div v-if="loadingDetail" class="pa-5">
        <Loader :loading="true" skin="light"></Loader>
      </div>
      <div v-else>
        <v-card color="grey lighten-4" :class="{'px-0': $vuetify.breakpoint.smAndDown}" class="elevation-0 px-2">
          <v-card-text class="pa-0">
            <v-layout row wrap>
              <v-flex xs12 sm6>
                Datum: <strong>{{detailItem.datum | formatDate}}</strong>
              </v-flex>
              <v-flex xs12 sm6>
                Variabilní symbol: <strong>{{detailItem.variabilni_symbol}}</strong>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm6>
                Stav: <strong>{{detailItem.stav_objednavky.nazev}}</strong>
              </v-flex>
              <v-flex xs12 sm6>
                Doručení: <strong v-if="detailItem.zpusob_doruceni!=null">{{detailItem.zpusob_doruceni.nazev}}</strong><strong v-else>--</strong>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card color="grey lighten-4" :class="{'px-0': $vuetify.breakpoint.smAndDown}" class="mt-3 px-2 elevation-0">
          <v-card-text class="pa-0">
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <h3 class="mb-3">Fakturační adresa:</h3>
                <adresa-view :adresa="detailItem.fa_adresa"></adresa-view>
              </v-flex>
              <v-flex xs12 sm6 :class="{'mt-3': $vuetify.breakpoint.xs}">
                <h3 class="mb-3">Doručovací adresa:</h3>
                <adresa-view :adresa="detailItem.dod_adresa"></adresa-view>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card color="grey lighten-4 mt-3" :class="{'pl-3 pr-3': $vuetify.breakpoint.smAndDown}" class="elevation-0">
          <h4 class="mx-0">Produkty v objednávce:</h4>
          <v-data-table
            :headers="detailProductsHeaders"
            :items="detailItem.polozky"
            hide-actions
            class="mt-3"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>
                  <eshop-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank" v-if="props.item.produkt!=null">{{props.item.produkt.nazev}}</eshop-link>
                  <span v-if="props.item.postovne">Poštovné</span>
                </td>
                <td class="text-xs-right">
                  {{props.item.castka_mj | formatMoney}} {{props.item.mena.zkratka}}
                </td>
                <td class="text-xs-right" v-if="zobrazit_slevu">
                  <span v-if="props.item.sleva>0">{{props.item.sleva | formatMoney}} {{props.item.mena.zkratka}}</span>
                  <span v-else></span>
                </td>
                <td class="text-xs-right">
                  {{props.item.mnozstvi}} ks
                </td>
                <td class="text-xs-right">
                  <span v-if="props.item.castka_dph_10>0">{{props.item.castka_dph_10 | formatMoney}} {{props.item.mena.zkratka}}</span>
                  <span v-else-if="props.item.castka_dph_15>0">{{props.item.castka_dph_15 | formatMoney}} {{props.item.mena.zkratka}}</span>
                  <span v-else-if="props.item.castka_dph_21>0">{{props.item.castka_dph_21 | formatMoney}} {{props.item.mena.zkratka}}</span>
                  <span v-else>0 {{props.item.mena.zkratka}}</span>
                </td>
                <!-- TODO klient nemá vidět kredity -->
                <!-- <td class="text-xs-right">
                  {{props.item.kredity | formatDouble}} kr.
                </td> -->
                <td class="text-xs-right">
                  <span v-html="computePrice(props.item.castka_mj - props.item.sleva, props.item.mnozstvi)"></span>&nbsp;{{props.item.mena.zkratka}}
                </td>
                <td class="text-xs-right">
                  <span v-if="props.item.castka_fixace > 0">
                    <span v-html="computePrice(props.item.castka_fixace, props.item.mnozstvi)"></span>&nbsp;{{props.item.mena.zkratka}}
                  </span>
                </td>
              </tr>
            </template>
            <template slot="footer">
              <tr>
                <td>Celkem bez DPH:</td>
                <td colspan="6" class="text-xs-right">
                  {{detailItem.castka_celkem_bez_dph | formatMoney}} {{detailItem.mena.zkratka}}
                </td>
              </tr>
              <tr v-if="detailItem.castka_celkem_dph_10>0">
                <td>DPH 10%</td>
                <td colspan="6" class="text-xs-right">
                  {{detailItem.castka_celkem_dph_10 | formatMoney}} {{detailItem.mena.zkratka}}
                </td>
              </tr>
              <tr v-if="detailItem.castka_celkem_dph_15>0">
                <td>DPH 15%</td>
                <td colspan="6" class="text-xs-right">
                  {{detailItem.castka_celkem_dph_15 | formatMoney}} {{detailItem.mena.zkratka}}
                </td>
              </tr>
              <tr v-if="detailItem.castka_celkem_dph_21>0">
                <td>DPH 21%</td>
                <td colspan="6" class="text-xs-right">
                  {{detailItem.castka_celkem_dph_21 | formatMoney}} {{detailItem.mena.zkratka}}
                </td>
              </tr>
              <tr>
                <td><strong>Celkem s DPH:</strong></td>
                <td colspan="6" class="text-xs-right">
                  {{detailItem.castka_celkem | formatMoney}} {{detailItem.mena.zkratka}}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-card-text>
    <v-card-actions class="mt-3 pa-0" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
      <!-- <a :href="moje ? (api_url + 'nakupy/jednorazove-nakupy/' + id + '/pdf') : (api_url + 'klient/nakupy/'+klient+'/jednorazove-nakupy/' + id + '/pdf')" target="_blank"><v-btn color="orange" dark depressed class="ma-0"><v-icon small class="mr-2">picture_as_pdf</v-icon>Stáhnout PDF objednávku</v-btn></a> -->
      <v-btn color="orange" dark depressed class="ma-0" @click="downloadPDF"><v-icon small class="mr-2">picture_as_pdf</v-icon>Stáhnout PDF objednávku</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="grey lighten-3 elevation-0" class="bold" @click="close">Zavřít</v-btn>
    </v-card-actions>
  </v-card>
  </v-dialog>
</template>

<script>
/*import RocniBonusy from '@/pages/Klienti/RocniBonusy'
import Platby from '@/pages/Klienti/Platby'
import PredaneProdukty from '@/pages/Klienti/PredaneProdukty'*/
export default {
  data () {
    return {
      dialogDetail: false,
      detailProductsHeaders: [],
      newItems: [],
      newItem: null,
      newItemCelkem: { bez_dph: 0, s_dph: 0, dph_10: 0, dph_15: 0, dph_21: 0 },
      updating: false,
      sending: false,
      valid: false,
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      rulesRequiredMoreThanZero: [
        (v) => !!v && v > 0 || "Pole je vyžadováno"
      ],
      dialogInit: {
        zpusob_doruceni: null,
        mena_id: null,
        dodaci_adresa: null,
        fakturacni_adresa: null,
        poznamka: null,
        variabilni_symbol: null
      },
      loadingDetail: false,
      zobrazit_slevu: false
    }
  },
  computed: {
    me () {
      return window.$me;
    },
    api_url () {
      return window.api.$api_url;
    }
  },
  props: {
    id: String,
    klient: String,
    moje: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dialogDetail (v) {
      if (!v)
        this.$emit("close");
    }
  },
  mounted: function() {
    this.loadingDetail = true;
    this.dialogDetail = true;
    if (typeof this.klient != "undefined" && this.klient != null) {
      window.API.get("klient/nakupy/"+this.klient+"/jednorazove-nakupy/"+this.id).then(function(body) {
        this.detailItem = body;
        this.zobrazit_slevu = false;
        body.polozky.forEach((e) => {
          if (typeof e.sleva != "undefined" && e.sleva != null && !isNaN(e.sleva) && parseFloat(e.sleva) > 0)
            this.zobrazit_slevu = true;
        });
        if (this.zobrazit_slevu) {
          this.detailProductsHeaders = [
            { text: "Produkt", value: "produkt", sortable: false },
            { text: "Cena/ks", value: "ceny", sortable: false, width: 150, align: "right" },
            { text: "Sleva/ks", value: "id", sortable: false, width: 150, align: "right" },
            { text: "Počet ks", value: "pocet", sortable: false, width: 150, align: "right" },
            { text: "DPH celkem", value: "id", sortable: false, width: 150, align: "right" },
            // TODO klient nemá vidět kredity
            // { text: "Kredity", value: "kredity", sortable: false, width: 150, align: "right" },
            { text: "Cena celkem s DPH", value: "ceny", sortable: false, width: 150, align: "right" },
            { text: "Částka fixace", value: "castka_fixace", sortable: false, width: 150, align: "right" }
          ]
        }
        else {
          this.detailProductsHeaders = [
            { text: "Produkt", value: "produkt", sortable: false },
            { text: "Cena/ks", value: "ceny", sortable: false, width: 150, align: "right" },
            { text: "Počet ks", value: "pocet", sortable: false, width: 150, align: "right" },
            { text: "DPH celkem", value: "id", sortable: false, width: 150, align: "right" },
            // TODO klient nemá vidět kredity
            // { text: "Kredity", value: "kredity", sortable: false, width: 150, align: "right" },
            { text: "Cena celkem s DPH", value: "ceny", sortable: false, width: 150, align: "right" },
            { text: "Částka fixace", value: "castka_fixace", sortable: false, width: 150, align: "right" }
          ]
        }
        this.loadingDetail = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.loadingDetail = false;
        this.dialogDetail = false;
      }.bind(this));
    }
    else {
      window.API.get("nakupy/jednorazove-nakupy/"+this.id).then(function(body) {
        this.detailItem = body;
        this.zobrazit_slevu = false;
        body.polozky.forEach((e) => {
          if (typeof e.sleva != "undefined" && e.sleva != null && !isNaN(e.sleva) && parseFloat(e.sleva) > 0)
            this.zobrazit_slevu = true;
        });
        if (this.zobrazit_slevu) {
          this.detailProductsHeaders = [
            { text: "Produkt", value: "produkt", sortable: false },
            { text: "Cena/ks", value: "ceny", sortable: false, width: 150, align: "right" },
            { text: "Sleva/ks", value: "id", sortable: false, width: 150, align: "right" },
            { text: "Počet ks", value: "pocet", sortable: false, width: 150, align: "right" },
            { text: "DPH celkem", value: "id", sortable: false, width: 150, align: "right" },
            // TODO klient nemá vidět kredity
            // { text: "Kredity", value: "kredity", sortable: false, width: 150, align: "right" },
            { text: "Cena celkem s DPH", value: "ceny", sortable: false, width: 150, align: "right" },
            { text: "Částka fixace", value: "castka_fixace", sortable: false, width: 150, align: "right" }
          ]
        }
        else {
          this.detailProductsHeaders = [
            { text: "Produkt", value: "produkt", sortable: false },
            { text: "Cena/ks", value: "ceny", sortable: false, width: 150, align: "right" },
            { text: "Počet ks", value: "pocet", sortable: false, width: 150, align: "right" },
            { text: "DPH celkem", value: "id", sortable: false, width: 150, align: "right" },
            // TODO klient nemá vidět kredity
            // { text: "Kredity", value: "kredity", sortable: false, width: 150, align: "right" },
            { text: "Cena celkem s DPH", value: "ceny", sortable: false, width: 150, align: "right" },
            { text: "Částka fixace", value: "castka_fixace", sortable: false, width: 150, align: "right" }
          ]
        }
        this.loadingDetail = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.loadingDetail = false;
        this.dialogDetail = false;
      }.bind(this));
    }
  },
  methods: {
    computePrice(c, q) {
      if (c == null || q == null || c <= 0 || q <= 0)
        return 0;
      return window.th.formatPrice(c*q, 2, ",", " ").replace(" ", "&nbsp;")
    },
    close () {
      this.$emit('close');
    },
    downloadPDF () {
      var url = this.moje ? ('nakupy/jednorazove-nakupy/' + this.id + '/pdf') : ('klient/nakupy/'+this.klient+'/jednorazove-nakupy/' + this.id + '/pdf');
      window.api.download(url);
    }
  },
  components: {
    //RocniBonusy, Platby, PredaneProdukty
  }
}
</script>
